// extracted by mini-css-extract-plugin
export default {"form":"form__dJXPcm","checkbox":"checkbox__fz5JhR"};